<template>
  <div
    data-test-editor-loader
    class="inset-0 bg-gray-800 bg-opacity-40 text-3xl font-semibold text-white absolute z-10 grid content-center items-center text-center"
  >
    Loading Editor...
  </div>
</template>
